/**
 * Protected Route Component
 * Checks if user is authenticated using MSAL before allowing access to protected routes
 */

import React from "react";
import { Navigate } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";

function ProtectedRoute({ children }) {
  // Use MSAL hooks to check authentication status
  const isAuthenticated = useIsAuthenticated();
  const { accounts } = useMsal();
  
  // Check localStorage for accessToken (set during auth callback or initialization)
  const accessToken = localStorage.getItem("accessToken");
  
  // User is authenticated if MSAL says so OR if we have an accessToken in localStorage
  const isLoggedIn = isAuthenticated || accounts.length > 0 || !!accessToken;
  
  // If not authenticated, redirect to login
  if (!isLoggedIn) {
    return <Navigate to="/authentication/sign-in/basic" replace />;
  }
  
  // If authenticated, return the protected component
  return children;
}

export default ProtectedRoute;
